import React, { useState, useEffect, useRef } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Typography,
  IconButton,
  Autocomplete,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import GetChargeAccount from "../Dropdowns/GetChargeAccount";
import CostCenter from "../Dropdowns/CostCenter";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  getCostCenterDataForExcel,
  getg_laccountForExcel,
  getCostCenterData_v2,
  getg_laccount_Search,
  getEmployeeByCostCenter,
} from "../../actions";
import isFutureDate from "../../../../Functions/isFutureDate";
import { formatDateTimeForBackend } from "../../../../Functions";
import { Delete } from "@material-ui/icons";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import moment from "moment";
import POAlertDialog from "./PoTableAlert";
import Heading from "../../../../StyledComponents/Heading/Heading";
import axios from "axios";
import { Backdrop } from "@material-ui/core";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import isOldDateValidate from "../../../../Functions/isOldDateValidate";

import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
  intColumn,
  floatColumn,
  resizeColumn,
} from "react-datasheet-grid";
import "react-datasheet-grid/dist/style.css";
const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

function ExpenseTable({
  formState,
  setFormState,
  editable,
  deletee,
  disabled,
  setOpenInvalidWarningDate,
  setInvalidWarningDateState,
}) {
  const classes = useStyles();
  const tableData = {
    expenseDate: moment().format("YYYY-MM-DD"),
    description: "",
    amount: 0,
    glAccount: "",
    accountType: "Debit",
    costCenter: "",
    fixedAsset: "",
    tType: "",
    profitCenter: "",
  };
  const [horizonIDList, setHorizonIDList] = useState([]);
  const [horizonLoading, setHorizonLoading] = useState(false);

  const [run, setRun] = useState(true);
  const [vendorListLoading, setVendorListLoading] = useState(false);

  const [costCenterList, setCostCenterList] = useState([]);
  const [costCenterLoading, setCostCenterLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [erralertMessage, setErrAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [gl_account, setGl_account] = useState([]);
  const [backDropLoader, setBackDropLoader] = useState(true);
  // useEffect(() => {
  //   if(formState.Expense_Accounts_list?.length > 0 ){
  //     let Expense_list = formState?.Expense_Accounts_list
  //     for (let i = 0; i < Expense_list?.length; i++) {
  //       const item =Expense_list[i];
  //
  //       if (costCenterList?.length > 0) {
  //         const finded = costCenterList.find(
  //           (x) => x.CostCenterCode === item?.costCenter?.CostCenterCode
  //         );

  //         const cost = finded|| "";

  //

  //       }

  //     }
  //   }

  // }, [costCenterList]);

  useEffect(() => {
    if (formState?.Expense_Accounts_list?.length > 0) {
      const updatedExpenseList = formState?.Expense_Accounts_list?.map(
        (item) => {
          const matchingCostCenter = costCenterList?.find(
            (x) =>
              x.CostCenterCode ===
              (item.costCenter?.CostCenterCode || item.costCenter)
          );
          // const matchglAccount = gl_account.find(x => x.GLAccount === item.glAccount);
          if (matchingCostCenter) {
            return {
              ...item,
              costCenter: matchingCostCenter,
              // glAccount:matchglAccount
            };
          } else {
            return item;
          }
        }
      );

      setFormState((prevFormState) => ({
        ...prevFormState,
        Expense_Accounts_list: updatedExpenseList,
      }));
    }
  }, [costCenterList, gl_account]);

  useEffect(() => {
    if (gl_account?.length > 0 && costCenterList?.length > 0) {
      setBackDropLoader(false);
    }
  }, [gl_account, costCenterList]);

  useEffect(() => {}, []);
  const [costCenterEmployeeLoading, setCostCenterEmployeeLoading] =
    useState(false);

  const myStyle = {
    width: "170px",
    marginTop: "10px",
    border: "none",
    outline: "none",
    fontFamily: "Arial",
    borderBottom: "1px solid #B4B4B4",
    "&:hover": {
      cursor: "text",
      borderBottom: "1px solid #000",
    },
  };
  const [CostLoading, setCostLoading] = useState([]);
  const [glAccountLoading, setGlAccountLoading] = useState(false);

  useEffect(() => {
    getCostCenterDataForExcel(
      "",
      setCostCenterLoading,
      setCostCenterList,
      setCostLoading
    );
    getg_laccountForExcel("", setLoading, setGl_account, setGlAccountLoading);
  }, []);

  const addInput = () => {
    setFormState((formState) => ({
      ...formState,
      Expense_Accounts_list: [...formState.Expense_Accounts_list, tableData],
    }));
  };
  const deleteInput = (index) => {
    setRun(true);
    const filteredData = formState?.Expense_Accounts_list?.filter(
      (x, i) => i !== index
    );
    setFormState((formState) => ({
      ...formState,
      Expense_Accounts_list: filteredData,
    }));
  };

  const changeHandler = (e, index) => {
    const { name, value } = e.target;

    let tempArray = formState.Expense_Accounts_list;
    tempArray[index] = {
      ...formState.Expense_Accounts_list[index],
      [name]: value,
    };

    if (name === "amount") {
      setRun(true);
    }
    if (name === "glAccount") {
      // tempArray[index] = {
      //   ...formState.Expense_Accounts_list[index],
      //   VendorCode: value,
      // };
    }

    if (name === "costCenter") {
      // getEmployeeByCostCenter(
      //   setCostCenterEmployeeLoading,
      //   value,
      //   tempArray,
      //   formState,
      //   index
      // );
      // tempArray[index] = {
      //   ...formState.Expense_Accounts_list[index],
      //   CostCenterOwner: costCenterEmployeeData.employeeCode
      //     ? costCenterEmployeeData.employeeCode
      //     : "Not Found",
      //   CostCenterOwnerName: costCenterEmployeeData.employeeName
      //     ? costCenterEmployeeData.employeeName
      //     : "Not Found",
      // };
    }

    setFormState((formState) => ({
      ...formState,
      Expense_Accounts_list: tempArray,
    }));
  };
  const [cellState, setCellState] = useState("");

  const handleGridChange = async (data, operation) => {
    let rowIndex = cellState?.cell?.row;
    let name = cellState?.cell?.colId;

    let tempArray = data;

    // for consumed quantity
    const updatedData = await Promise.all(
      data.map(async (row) => {
        let ab = { costCenterData: "" };
        if (row?.costCenter) {
          await getEmployeeByCostCenter(row?.costCenter, setLoading, ab);
        }

        let costCenterOwner = row?.costCenter
          ? ab.costCenterData.employeeCode
            ? ab.costCenterData.employeeCode
            : "No Found"
          : "";
        let costCenterOwnerName = row?.costCenter
          ? ab.costCenterData.employeeName
            ? ab.costCenterData.employeeName
            : "Not Found"
          : "";
        return {
          ...row,

          expenseDate: moment(row.expenseDate).format("YYYY-MM-DD"),
          description: row?.description || "",
          amount: row?.amount || "0",
          glAccount: row?.glAccount || "",
          accountType: "Debit",
          costCenter: row?.costCenter || "",
          costCenterOwner: costCenterOwner || "",
          costCenterOwnerName: costCenterOwnerName || "",
          fixedAsset: row?.fixedAsset || "",
          tType: row?.tType || "",
          profitCenter: row?.profitCenter || "",
        };
      })
    );

    if (name === "amount") {
      setRun(true);
    }
    setFormState((formState) => ({
      ...formState,
      Expense_Accounts_list: updatedData,
    }));

    // setFormState((formState) => ({
    //   ...formState,
    //   Expense_Accounts_list:{
    //     expenseDate: moment( tempArray.expenseDate).format("YYYY-MM-DD"),
    //     description: tempArray?.description || "",
    //     amount: tempArray?.amount || 0,
    //     glAccount:tempArray?.glAccount || "",
    //     costCenter:tempArray?.costCenter || "",
    //     fixedAsset:tempArray?.fixedAsset || "",
    //     tType:tempArray?.tType ||  "",
    //     profitCenter:tempArray?.profitCenter || "",
    //     }
    // }));
  };
  const dateChangeHandler = (e, index) => {
    const { name, value } = e.target;

    let tempArray = formState.Expense_Accounts_list;
    tempArray[index] = {
      ...formState.Expense_Accounts_list[index],
      [name]: value,
    };

    setFormState((formState) => ({
      ...formState,
      Expense_Accounts_list: tempArray,
    }));
  };

  // useEffect(() => {
  //   if (formState?.Expense_Accounts_list?.length > 0 && run) {
  //     const total = formState?.Expense_Accounts_list?.reduce(
  //       (accumulator, currentValue) => {
  //         return accumulator + Number(currentValue.amount);
  //       },
  //       0
  //     );
  //     setFormState((formState) => ({
  //       ...formState,
  //       invoice_Amount: total,
  //     }));
  //   }
  //   setRun(false);
  // }, [formState?.Expense_Accounts_list, run]);
  const calculateTotalAmount = () => {
    const totalAmount = formState?.Expense_Accounts_list?.reduce(
      (accumulator, currentValue) => {
        return accumulator + Number(Number(currentValue?.amount)?.toFixed(2));
      },
      0
    );

    return totalAmount;
  };
  const totalAmount = calculateTotalAmount();
  useEffect(() => {
    setFormState((formState) => ({
      ...formState,
      invoice_Amount: totalAmount,
    }));
  }, [totalAmount]);
  const DateCell = React.memo(({ rowData, setRowData }) => {
    return (
      <>
        {!editable ? (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              // value={value}
              // onChange={(newValue) => {
              //   setValue(newValue);
              // }}
              value={rowData}
              disabled={!editable || disabled}
              name="expenseDate"
              onChange={(e) => {
                setRowData(e.target.value);
              }}
              error={false}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  id="outlined-basic"
                  label="Outlined"
                  variant="standard"
                  disabled={!editable || disabled}
                  {...params}
                  error={false}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        ) : (
          <input
            type="date"
            max="9999-12-31"
            disabled={!editable || disabled}
            style={myStyle}
            // oninput event occurs immediately after the content has been changed,
            //while onchange occurs when the element loses focus
            name="expenseDate"
            onChange={(e) => {
              setRowData(e.target.value);
            }}
            onInput={(newValue) => {
              isOldDateValidate(
                formatDateTimeForBackend(newValue),
                setOpenInvalidWarningDate,
                setInvalidWarningDateState
                // setFormState
              );
            }}
            onBlur={(e) => {
              isOldDateValidate(
                formatDateTimeForBackend(e.target.value),
                setOpenInvalidWarningDate,
                setInvalidWarningDateState
                // setFormState
              );
            }}
            value={rowData}
            error={false}
            InputProps={{
              disableUnderline: true,
            }}
          />
        )}
      </>
    );
  });
  // const AmountCell = React.memo(({ rowData, setRowData }) => {
  //   return (
  //     <TextField
  //       type="number"
  //       // name="amount"
  //       // size="small"
  //       // value={rowData?.amount}
  //       sx={{
  //         "& legend": { display: "none" },
  //         "& fieldset": { top: 0 },
  //       }}
  //       InputProps={{

  //         disableUnderline: true,
  //       }}
  //       min={0}
  //       style={{ paddingBottom: "8px" }}
  //       variant="standard"
  //       required
  //       value={rowData}
  //       disabled={!editable || disabled}
  //       onChange={(e) => setRowData(e.target.value)}
  //     />
  //   );
  // });
  const CostCenterComponent = React.memo(
    ({
      active,
      rowData,
      setRowData,
      focus,
      stopEditing,
      columnData,
      disabled,
    }) => {
      const ref = useRef(null);
      useEffect(() => {
        if (focus) {
          ref.current?.focus();
        } else {
          ref.current?.blur();
        }
      }, [focus]);
      const [choices, setChoices] = useState(columnData.choices);
      useEffect(() => {
        getCostCenterData_v2(rowData, setLoading, setChoices);

        // getCostCenterDataByID(rowData);
      }, [rowData]);

      return (
        <>
          <FormControl fullWidth>
            <Autocomplete
              ref={ref}
              style={{ width: "100%" }}
              disabled={!editable || disabled}
              value={
                // Ensure that rowData is an object before trying to access its properties
                rowData
                  ? choices.find(
                      (option) =>
                        option.data?.CostCenterCode === rowData ||
                        option.label === rowData
                    ) || {
                      value: "",
                      label: "",
                    }
                  : null
              }
              onChange={(event, newValue) => {
                const selectedVendor = newValue?.value;
                setRowData(selectedVendor);
                setTimeout(stopEditing, 0);

                if (
                  newValue?.data?.IsActive != "True" &&
                  newValue?.data != null
                ) {
                  setAlertMessage(true);
                  setErrAlertMessage("This Cost Center  has been Blocked");
                }
              }}
              options={choices}
              getOptionLabel={(option) => option?.label}
              loading={costCenterLoading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  size="small"
                  onChange={(event) => {
                    getCostCenterData_v2(
                      event.target.value,
                      setLoading,
                      setChoices
                    );
                  }}
                  required
                />
              )}
            />
          </FormControl>

          {/*{() => ( */}
        </>
      );
    }
  );
  const SelectComponent = React.memo(
    ({ active, rowData, setRowData, focus, stopEditing, columnData }) => {
      const ref = useRef(null);
      //
      useEffect(() => {
        if (focus) {
          ref.current?.focus();
        } else {
          ref.current?.blur();
        }
      }, [focus]);
      const [choices, setChoices] = useState(columnData.choices);

      useEffect(() => {
        getg_laccount_Search(rowData, setLoading, setChoices);
      }, [rowData]);
      return (
        <>
          <FormControl fullWidth>
            <Autocomplete
              ref={ref}
              style={{ width: "100%" }}
              disabled={!editable || disabled}
              // value={
              //   // Ensure that rowData is an object before trying to access its properties
              //   rowData
              //     ? columnData.choices.find(
              //         (option) => option.value === rowData
              //       )
              //     : null
              // }

              value={
                // Ensure that rowData is an object before trying to access its properties
                rowData
                  ? choices.find((option) => option.value === rowData) || {
                      value: "",
                      label: "",
                    }
                  : null
              }
              onChange={(event, newValue) => {
                const selectedVendor = newValue?.value;
                setRowData(selectedVendor);
                setTimeout(stopEditing, 0);

                if (
                  newValue?.data?.IsActive != "True" &&
                  newValue?.data != null
                ) {
                  setAlertMessage(true);
                  setErrAlertMessage("This Gl Account has been Blocked");
                }
              }}
              // options={columnData.choices}
              options={choices}
              getOptionLabel={(option) => option?.label}
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  size="small"
                  onChange={(event) => {
                    getg_laccount_Search(
                      event?.target?.value,
                      setLoading,
                      setChoices
                    );
                  }}
                  required
                />
              )}
            />
          </FormControl>
        </>
      );
    }
  );
  // const intColumn = {
  //   component: AmountCell,
  //   deleteValue: () => "",
  //   copyValue: ({ rowData }) => rowData,
  //   pasteValue: ({ value }) => value,
  // };
  const dateColumn = {
    component: DateCell,
    deleteValue: () => "",
    copyValue: ({ rowData }) => rowData,
    pasteValue: ({ value }) => value,
  };
  const selectColumn = (options) => ({
    component: SelectComponent,
    columnData: options,
    disableKeys: true,
    keepFocus: true,
    copyValue: ({ rowData }) => rowData,
    pasteValue: ({ value }) => {
      const paddedValue = value.padStart(10, "0");
      return paddedValue;
    },
    // copyValue: ({ rowData }) => {
    //   const selectedChoice = options.choices.find(choice => choice.data === rowData);
    //   return selectedChoice ? selectedChoice.label : '';
    // },
    // pasteValue: ({ value }) => {
    //   const selectedChoice = options.choices.find(choice => choice.label === value);
    //   return selectedChoice ? selectedChoice.data : null;
    // }
  });
  const costselectColumn = (options) => ({
    component: CostCenterComponent,
    columnData: options,
    disableKeys: true,
    keepFocus: true,

    copyValue: ({ rowData }) => rowData,
    pasteValue: ({ value }) => value,
    // copyValue: ({ rowData }) => {
    //   const selectedChoice = options.choices.find(
    //     (choice) => choice.data === rowData
    //   );
    //   return selectedChoice ? selectedChoice.label : "";
    // },
    // pasteValue: ({ value }) => {
    //   const selectedChoice = options.choices.find(
    //     (choice) => choice.label === value
    //   );
    //   return selectedChoice ? selectedChoice.data : null;
    // },
  });

  const columns = [
    {
      ...keyColumn("expenseDate", dateColumn),
      title: "Expense Date",
      minWidth: 160,

      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: !editable || disabled,
    },

    {
      ...keyColumn("description", textColumn),
      title: "Description",
      minWidth: 270,

      // disabled: true,
      disabled: !editable || disabled,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      ...keyColumn("amount", floatColumn),
      title: "Amount",
      minWidth: 200,
      // width: 150,
      // disabled: true,
      disabled: !editable || disabled,
      pasteValue: ({ rowData, value, rowIndex }) => {
        rowData.amount = Number(value.replace(/,/g, "")) || 0;
        return rowData;
      },

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    editable
      ? {
          ...keyColumn(
            "glAccount",
            selectColumn({
              choices: gl_account?.map((account, i) => ({
                data: account,
                value: `${account.GLAccount}`,
                label: `${account.GLAccount} - ${account.ShortText}`,
              })),
            })
          ),
          title: "GL Account",
          minWidth: 270,
          disabled: !editable || disabled,
        }
      : {
          ...keyColumn("glAccount", textColumn),
          title: "GL Account",
          minWidth: 430,
          disabled: !editable || disabled,
        },
    // {
    //   ...keyColumn(
    //     "glAccount",
    //     // selectColumn({
    //     //   choices: gl_account, // Use the updated choices variable here
    //     // })
    //     selectColumn({
    //       choices: gl_account?.map((account, i) => ({
    //         data: account,
    //         value: `${account.GLAccount}`,
    //         label: `${account.GLAccount} - ${account.ShortText}`,
    //       })),
    //     })
    //   ),
    //   title: "GL Account",
    //   minWidth: 270,
    //   disabled: !editable || disabled,
    // },
    editable
      ? {
          ...keyColumn(
            "costCenter",
            costselectColumn({
              choices: costCenterList?.map((account, i) => ({
                data: account,
                value: `${account.CostCenterCode}`,
                label: `${account.CostCenterCode} - ${account.Name}`,
              })),
            })
          ),
          title: "Cost Center",
          minWidth: 270,
          disabled: ({ rowData }) => {
            if (rowData?.profitCenter || disabled || !editable) {
              return true;
            }
            return false;
          },

          // disabled: !editable || disabled,

          // grow: 2,
        }
      : {
          ...keyColumn("costCenter", textColumn),
          title: "Cost Center",
          minWidth: 340,
          disabled: ({ rowData }) => {
            if (rowData?.profitCenter || disabled || !editable) {
              return true;
            }
            return false;
          },
        },
    {
      ...keyColumn("fixedAsset", textColumn),
      title: "Fixed Asset",
      width: 150,
      // grow: 4,
      // disabled: ({ disabled }) => (disabled ? true : false),
      // disabled: true,
      disabled: !editable || disabled,
    },
    {
      ...keyColumn("tType", textColumn),
      title: "TType",
      width: 100,
      disabled: !editable || disabled,

      // grow: 3,
      // disabled: ({ disabled }) => (disabled ? true : false),
      // disabled: true,
    },
    {
      ...keyColumn("profitCenter", intColumn),
      title: "Profit Center",
      width: 100,
      // disabled: !editable || disabled,
      disabled: ({ rowData }) => {
        if (rowData?.costCenter || disabled || !editable) {
          return true;
        }
        return false;
      },
    },

    // will be called to handle pasting. Because we chose to copy the label, we have to transform it back to a value on pasting.
  ];
  return (
    <div>
      <Grid container>
        {/* <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={backDropLoader}

          >
          <CircularProgress color="inherit" />


          </Backdrop> */}
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
          <Typography variant="h5" component="h2" style={{ marginTop: "10px" }}>
            <Heading title="Expense Detail" />
          </Typography>
          {/* {   <TableContainer component={Paper} className="scrollable">
            <Table
              aria-label="simple table"
              size="small"
              className={classes.table}
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Expense Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Description
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Amount{" "}
                  </TableCell>
                  <TableCell
                    style={{
                      padding: 0,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#031c30",
                      width: "14%",
                    }}
                  >
                    Gl Account
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031c30" }}
                    style={{ width: "14%" }}
                  >
                    Cost Center
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Fixed Asset
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    TType
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Profit Center
                  </TableCell>
                  {(deletee || !disabled) && (
                    <TableCell
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "#031c30",
                      }}
                    >
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {formState?.Expense_Accounts_list?.map((item, index) => {
                  amountTotal = amountTotal + parseInt(item.amount);
                  return (
                    <>
                      <TableRow>
                        <TableCell scope="row">
                          {!editable ? (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                // value={value}
                                // onChange={(newValue) => {
                                //   setValue(newValue);
                                // }}
                                disabled={!editable || disabled}
                                name="expenseDate"
                                onChange={(newValue) =>
                                  dateChangeHandler(newValue, index)
                                }
                                value={item.expenseDate}
                                error={false}
                                renderInput={(params) => (
                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="outlined-basic"
                                    label="Outlined"
                                    variant="standard"
                                    disabled={!editable || disabled}
                                    {...params}
                                    error={false}
                                    sx={{
                                      "& legend": { display: "none" },
                                      "& fieldset": { top: 0 },
                                    }}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          ) : (
                            <input
                              type="date"
                              max="9999-12-31"
                              disabled={!editable || disabled}
                              style={myStyle}
                              // oninput event occurs immediately after the content has been changed,
                              //while onchange occurs when the element loses focus
                              name="expenseDate"
                              onChange={(newValue) => {
                                dateChangeHandler(newValue, index);
                              }}
                              value={item.expenseDate}
                              error={false}
                            />
                          )}
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="text"
                            name="description"
                            value={item.description}
                            size="small"
                            sx={{
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            disabled={!editable || disabled}
                            variant="standard"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>

                        <TableCell>
                          <TextField
                            // fullWidth
                            type="number"
                            name="amount"
                            value={item.amount}
                            size="small"
                            sx={{
                              // width: "70%",
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            id="outlined-basic"
                            disabled={!editable || disabled}
                            variant="standard"
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          {" "}
                          <FormControl fullWidth size="small">
                            <GetChargeAccount
                              GLAccount={item?.glAccount}
                              item={item}
                              changeHandler={changeHandler}
                              index={index}
                              bordered={false}
                              disabled={!editable || disabled}
                              setAlertMessage={setAlertMessage}
                            />
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <CostCenter
                              value={
                                item?.costCenter ||
                                item?.CostCenter || {
                                  CostCenterCode: "",
                                  Name: "",
                                }
                              }
                              changeHandler={changeHandler}
                              costCenter={
                                item?.costCenter?.CostCenterCode || ""
                              }
                              index={index}
                              bordered={false}
                              disabled={!editable || disabled}
                              setAlertMessage={setAlertMessage}
                            />
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="text"
                            name="fixedAsset"
                            value={item.fixedAsset}
                            size="small"
                            sx={{
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            variant="standard"
                            onChange={(event) => changeHandler(event, index)}
                            disabled={!editable || disabled}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="text"
                            name="tType"
                            value={item.tType}
                            size="small"
                            sx={{
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            variant="standard"
                            onChange={(event) => changeHandler(event, index)}
                            disabled={!editable || disabled}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            name="profitCenter"
                            value={item.profitCenter}
                            size="small"
                            sx={{
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            variant="standard"
                            onChange={(event) => changeHandler(event, index)}
                            disabled={!editable || disabled}
                          />
                        </TableCell>
                        {(deletee || !disabled) && (
                          <TableCell align="center">
                            <IconButton size="small">
                              <Delete
                                color="error"
                                fontSize="small"
                                onClick={() => {
                                  deleteInput(index);
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>
                      {formState?.Expense_Accounts_list?.length ===
                        index + 1 && (
                        <TableRow>
                          <TableCell colSpan={2} align="center">
                            <b>Invoice Amount</b>
                          </TableCell>
                          <TableCell colSpan={3}>
                            {formState.invoice_Amount}
                          </TableCell>
                   <TableCell colSpan={3}>{amountTotal}</TableCell>
                        </TableRow>
                      )}
                    </>
                  );
                })}
              </TableBody>
              {!formState?.Expense_Accounts_list && (
                <TableSkeleton noOfColumns={11} noOfLines={3} />
              )}
            </Table>
            {formState?.Expense_Accounts_list?.length === 0 ? (
              <EmptyData />
            ) : (
              ""
            )}
            </TableContainer>  */}
          {gl_account.length > 0 && costCenterList.length > 0 ? (
            <>
              <DataSheetGrid
                style={{
                  "--dsg-header-text-color": "#031C30",
                }}
                // value={
                //   formState?.Expense_Accounts_list?.length == 0
                //     ? [...tableData]
                //     : [...formState.Expense_Accounts_listt?.map(item => {
                //       return {
                //           ...item,
                //           amount: Number(Number(item?.amount)?.toFixed(2))
                //       };
                //   })]
                // }
                value={
                  (formState?.Expense_Accounts_list && [
                    ...formState?.Expense_Accounts_list?.map((item) => {
                      return {
                        ...item,
                        amount: Number(Number(item?.amount)?.toFixed(2)),
                      };
                    }),
                  ]) ||
                  []
                }
                // value={formState?.Expense_Accounts_list}
                onChange={handleGridChange}
                columns={columns}
                lockRows={!editable || disabled}
                //  lockRows={(disabled || formState.invoicePORef_List.length === 0) ? true: false}

                onActiveCellChange={(res) => {
                  setCellState(res);
                }}

                // onDelete={handleDelete}
              />
              <TableContainer>
                {formState?.Expense_Accounts_list?.length > 0 && (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      <b>Invoice Amount</b>
                    </TableCell>
                    <TableCell colSpan={3}>{totalAmount}</TableCell>
                    {/* <TableCell colSpan={3}>{amountTotal}</TableCell> */}
                  </TableRow>
                )}
              </TableContainer>
            </>
          ) : (
            <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
              <LinearProgress color="info" />
              <LinearProgress color="info" />
              <LinearProgress color="info" />
            </Stack>
          )}

          {/* {editable && (
            <Box display="flex" justifyContent={"flex-end"} mt={2}>
              <Button
                color="secondary"
                variant="contained"
                onClick={addInput}
                style={{ display: disabled ? "none" : "" }}
              >
                Add New Row
              </Button>
            </Box>
          )} */}
          {alertMessage && (
            <POAlertDialog
              setAlertMessage={setAlertMessage}
              message={erralertMessage}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default ExpenseTable;
const a = [
  {
    ChargeAccountID: "1",
    CompanyCode: "",
    GLAccount: "0000130101",
    ShortText: "Gross Salary",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "2",
    CompanyCode: "",
    GLAccount: "0000130102",
    ShortText: "Overtime",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "3",
    CompanyCode: "",
    GLAccount: "0000130103",
    ShortText: "Gratuity DB fund",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "4",
    CompanyCode: "",
    GLAccount: "0000130104",
    ShortText: "EOBI",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "5",
    CompanyCode: "",
    GLAccount: "0000130105",
    ShortText: "Temp/Contract Staff",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "6",
    CompanyCode: "",
    GLAccount: "0000130106",
    ShortText: "Fuel On Compensation Car",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "7",
    CompanyCode: "",
    GLAccount: "0000130107",
    ShortText: "Recruitment",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "8",
    CompanyCode: "",
    GLAccount: "0000130108",
    ShortText: "Relocation",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "9",
    CompanyCode: "",
    GLAccount: "0000130109",
    ShortText: "Vacation Accrual",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "10",
    CompanyCode: "",
    GLAccount: "0000130110",
    ShortText: "Club Membership/Subscription",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "11",
    CompanyCode: "",
    GLAccount: "0000130111",
    ShortText: "Medical Kitty",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "12",
    CompanyCode: "",
    GLAccount: "0000130112",
    ShortText: "Dental Care",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "13",
    CompanyCode: "",
    GLAccount: "0000130113",
    ShortText: "Medical Care",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "14",
    CompanyCode: "",
    GLAccount: "0000130114",
    ShortText: "Salaries Allocation From ECPL",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "15",
    CompanyCode: "",
    GLAccount: "0000130115",
    ShortText: "Car Earn Out Expense",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "16",
    CompanyCode: "",
    GLAccount: "0000130116",
    ShortText: "Expats Salaries",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "17",
    CompanyCode: "",
    GLAccount: "0000130117",
    ShortText: "House Rent Recovery",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "18",
    CompanyCode: "",
    GLAccount: "0000130118",
    ShortText: "Guest House Recovery",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "19",
    CompanyCode: "",
    GLAccount: "0000130119",
    ShortText: "Stipend",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "20",
    CompanyCode: "",
    GLAccount: "0000130120",
    ShortText: "Variable Pay Plan",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "21",
    CompanyCode: "",
    GLAccount: "0000130121",
    ShortText: "HOME OWNERSHIP ASSISTANCE",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "22",
    CompanyCode: "",
    GLAccount: "0000130122",
    ShortText: "Disturbance Allowance",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "23",
    CompanyCode: "",
    GLAccount: "0000130123",
    ShortText: "Target Incentive allowance",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "24",
    CompanyCode: "",
    GLAccount: "0000130124",
    ShortText: "Group Medical/Group Term Life Insurance Exp",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "25",
    CompanyCode: "",
    GLAccount: "0000130125",
    ShortText: "OTHERS- EMPLOYEE BENEFITS",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "26",
    CompanyCode: "",
    GLAccount: "0000130128",
    ShortText: "VPP - COGS",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "27",
    CompanyCode: "",
    GLAccount: "0000130129",
    ShortText: "Car Amoritization Expense",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "2/15/2018 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "2/16/2018 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "28",
    CompanyCode: "",
    GLAccount: "0000130201",
    ShortText: "Training Cost",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "29",
    CompanyCode: "",
    GLAccount: "0000130202",
    ShortText: "Training Related Travel Cost",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "30",
    CompanyCode: "",
    GLAccount: "0000130203",
    ShortText: "CONSULTANT/ INSTRUCTORS FEES-TRAINING & EDUCATION",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "31",
    CompanyCode: "",
    GLAccount: "0000130301",
    ShortText: "Rent",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "32",
    CompanyCode: "",
    GLAccount: "0000130302",
    ShortText: "Electricity",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "33",
    CompanyCode: "",
    GLAccount: "0000130303",
    ShortText: "Fuel/Diesel",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "34",
    CompanyCode: "",
    GLAccount: "0000130304",
    ShortText: "Gas & Water",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "35",
    CompanyCode: "",
    GLAccount: "0000130305",
    ShortText: "Machinery For Feeding",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "9/29/2020 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "9/29/2020 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "36",
    CompanyCode: "",
    GLAccount: "0000130306",
    ShortText: "Transportation",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "37",
    CompanyCode: "",
    GLAccount: "0000130307",
    ShortText: "Oil/Grease",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "38",
    CompanyCode: "",
    GLAccount: "0000130401",
    ShortText: "Office Supplies (Including Printing & Stationery,",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "39",
    CompanyCode: "",
    GLAccount: "0000130402",
    ShortText: "Books/Periodicals/Others",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "40",
    CompanyCode: "",
    GLAccount: "0000130403",
    ShortText: "Network Maintenance",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "41",
    CompanyCode: "",
    GLAccount: "0000130404",
    ShortText: "Canteen, Horticulture And Supplies",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "42",
    CompanyCode: "",
    GLAccount: "0000130405",
    ShortText: "Safety Material & Consumables",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "43",
    CompanyCode: "",
    GLAccount: "0000130406",
    ShortText: "Laboratory Services",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "44",
    CompanyCode: "",
    GLAccount: "0000130407",
    ShortText: "Rural development Merchandising Cost",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "45",
    CompanyCode: "",
    GLAccount: "0000130501",
    ShortText: "Non Cap Office Equipment & Furnitures",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "46",
    CompanyCode: "",
    GLAccount: "0000130502",
    ShortText: "Computer Software - Below Capitalization Threshold",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "47",
    CompanyCode: "",
    GLAccount: "0000130601",
    ShortText: "MNR Material Plant",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "48",
    CompanyCode: "",
    GLAccount: "0000130602",
    ShortText: "MNR Services Plant",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "49",
    CompanyCode: "",
    GLAccount: "0000130603",
    ShortText: "MNR Material - Chillers",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "50",
    CompanyCode: "",
    GLAccount: "0000130604",
    ShortText: "MNR Services - Chillers",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "51",
    CompanyCode: "",
    GLAccount: "0000130605",
    ShortText: "MNR Material - Generator",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "52",
    CompanyCode: "",
    GLAccount: "0000130606",
    ShortText: "MNR Services - Generator",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "53",
    CompanyCode: "",
    GLAccount: "0000130607",
    ShortText: "MNR Material - Milk Tanker",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "54",
    CompanyCode: "",
    GLAccount: "0000130608",
    ShortText: "MNR Services - Milk Tanker",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "55",
    CompanyCode: "",
    GLAccount: "0000130609",
    ShortText: "MNR Material - PHE",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "56",
    CompanyCode: "",
    GLAccount: "0000130610",
    ShortText: "MNR Services - PHE",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "57",
    CompanyCode: "",
    GLAccount: "0000130611",
    ShortText: "MNR - Freezers",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "58",
    CompanyCode: "",
    GLAccount: "0000130612",
    ShortText: "MNR - Lab Consumables",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "59",
    CompanyCode: "",
    GLAccount: "0000130613",
    ShortText: "MNR - Tools",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "60",
    CompanyCode: "",
    GLAccount: "0000130614",
    ShortText: "MNR - Trikes",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "61",
    CompanyCode: "",
    GLAccount: "0000130645",
    ShortText: "MNR - Others",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "62",
    CompanyCode: "",
    GLAccount: "0000130651",
    ShortText: "Third Party Man Power",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "63",
    CompanyCode: "",
    GLAccount: "0000130652",
    ShortText: "MnR Services - Others",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "64",
    CompanyCode: "",
    GLAccount: "0000130653",
    ShortText: "MnR - Weighbridge",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "65",
    CompanyCode: "",
    GLAccount: "0000130701",
    ShortText: "Price Difference Store & Spares",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "66",
    CompanyCode: "",
    GLAccount: "0000130702",
    ShortText: "Revaluation Of Material Store & Spares",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "3/7/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "3/8/2021 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "67",
    CompanyCode: "",
    GLAccount: "0000130703",
    ShortText: "Expense/Income From Transf Post Of Store & Spares",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "5/2/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "68",
    CompanyCode: "",
    GLAccount: "0000130704",
    ShortText: "Physical Inventory Adjustment Store & Spares",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "69",
    CompanyCode: "",
    GLAccount: "0000130705",
    ShortText: "Scrapping Of  Store & Spares",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "70",
    CompanyCode: "",
    GLAccount: "0000130706",
    ShortText: "Exchange Rate Difference",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "2/15/2018 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "2/16/2018 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "71",
    CompanyCode: "",
    GLAccount: "0000130801",
    ShortText: "Postage",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "72",
    CompanyCode: "",
    GLAccount: "0000130802",
    ShortText: "Telephones",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "73",
    CompanyCode: "",
    GLAccount: "0000130803",
    ShortText: "Internet",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "74",
    CompanyCode: "",
    GLAccount: "0000130804",
    ShortText: "DXX & Bandwidth Charges",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "9/29/2020 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "9/29/2020 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "75",
    CompanyCode: "",
    GLAccount: "0000130805",
    ShortText: "Other Communication",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "76",
    CompanyCode: "",
    GLAccount: "0000130901",
    ShortText: "Local Travel (Tickets, Visa & Boarding)",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "77",
    CompanyCode: "",
    GLAccount: "0000130902",
    ShortText: "Overseas Travel (Tickets, Visa & Boarding)",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "78",
    CompanyCode: "",
    GLAccount: "0000130903",
    ShortText: "Daily Tour Allowance",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "79",
    CompanyCode: "",
    GLAccount: "0000130904",
    ShortText: "Guest House Reocovery",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "80",
    CompanyCode: "",
    GLAccount: "0000131001",
    ShortText: "Meetings With Business Partners",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "81",
    CompanyCode: "",
    GLAccount: "0000131002",
    ShortText: "Staff Meetings & Conferences",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "82",
    CompanyCode: "",
    GLAccount: "0000131003",
    ShortText: "Directors Fee",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "83",
    CompanyCode: "",
    GLAccount: "0000131004",
    ShortText: "Function & Events",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "84",
    CompanyCode: "",
    GLAccount: "0000131005",
    ShortText: "Annual General Meeting & Other Events",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "85",
    CompanyCode: "",
    GLAccount: "0000131101",
    ShortText: "DistribSalesman In",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "86",
    CompanyCode: "",
    GLAccount: "0000131102",
    ShortText: "DistributorIncenti",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "87",
    CompanyCode: "",
    GLAccount: "0000131103",
    ShortText: "SD Infrastructure cost",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "88",
    CompanyCode: "",
    GLAccount: "0000131104",
    ShortText: "Preferred Dealer Network",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "2/15/2018 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "2/16/2018 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "89",
    CompanyCode: "",
    GLAccount: "0000131105",
    ShortText: "Trade Sampling",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "90",
    CompanyCode: "",
    GLAccount: "0000131106",
    ShortText: "Trade Sampling - Employees",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "91",
    CompanyCode: "",
    GLAccount: "0000131107",
    ShortText: "Food Challan Expense",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "92",
    CompanyCode: "",
    GLAccount: "0000131108",
    ShortText: "Secondary Sales System",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "93",
    CompanyCode: "",
    GLAccount: "0000131109",
    ShortText: "Distributor Inome Tax Expenses",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "94",
    CompanyCode: "",
    GLAccount: "0000131110",
    ShortText: "Expiry Products",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "95",
    CompanyCode: "",
    GLAccount: "0000131111",
    ShortText: "Outstation Handling",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "96",
    CompanyCode: "",
    GLAccount: "0000131112",
    ShortText: "Export Expenses",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "97",
    CompanyCode: "",
    GLAccount: "0000131113",
    ShortText: "Service Charges - Export",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "98",
    CompanyCode: "",
    GLAccount: "0000131114",
    ShortText: "Eds Charges - Export",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
  {
    ChargeAccountID: "99",
    CompanyCode: "",
    GLAccount: "0000131115",
    ShortText: "Short Payment - Export",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "4/23/2017 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "6/1/2017 12:00:00 AM",
    IsActive: "False",
  },
  {
    ChargeAccountID: "100",
    CompanyCode: "",
    GLAccount: "0000131116",
    ShortText: "Distributor Incentive & JBP",
    LongText: "",
    CreatedBy: "Administrator",
    CreatedDate: "12/1/2021 12:00:00 AM",
    ModifiedBy: "Administrator",
    ModifiedDate: "12/1/2021 12:00:00 AM",
    IsActive: "True",
  },
];
